import { render } from "./OrderInvoiceForm.vue?vue&type=template&id=3e89d91c&scoped=true"
import script from "./OrderInvoiceForm.vue?vue&type=script&lang=js"
export * from "./OrderInvoiceForm.vue?vue&type=script&lang=js"

import "./OrderInvoiceForm.vue?vue&type=style&index=0&id=3e89d91c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e89d91c"]])

export default __exports__